import { render } from "./CompanyTwoFactorPolicySwitch.vue?vue&type=template&id=19f10f0c&scoped=true"
import script from "./CompanyTwoFactorPolicySwitch.vue?vue&type=script&lang=js"
export * from "./CompanyTwoFactorPolicySwitch.vue?vue&type=script&lang=js"

import "./CompanyTwoFactorPolicySwitch.vue?vue&type=style&index=0&id=19f10f0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f10f0c"]])

export default __exports__